import classNames from 'classnames';
import { useState } from 'react';

import { ChatMode, Conversation } from '@/explore/types';

import { UserMessageInput } from '../chat-cell/components/user-message-input';

import styles from './conversation-cell.module.scss';

interface ConversationInptProps {
  floating?: boolean;
  sources?: string[];
  onCancel(): void;
  onSubmit(
    message: string,
    sources: string[],
    mode: ChatMode,
  ): Promise<{ conversation: Conversation | null; error: Error | undefined }>;
}

export const ConversationInput = ({
  floating,
  sources,
  onSubmit,
  onCancel,
}: ConversationInptProps) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (message: string, sources: string[], mode: ChatMode) => {
    setLoading(true);
    await onSubmit(message, sources, mode);
    setLoading(false);
  };

  return (
    <div className={classNames(styles.messageInput, floating === true ? styles.floating : null)}>
      <UserMessageInput
        placeholder="Follow up or request edits"
        sources={sources}
        onSubmit={handleSubmit}
        onCancel={onCancel}
        autoFocus
        primaryActions={(value, sources, mode) => [
          {
            label: 'Ask',
            disabled: loading || value.length === 0,
            onClick: () => onSubmit(value, sources, mode),
          },
        ]}
        secondaryActions={[{ label: 'Cancel (Esc)', onClick: onCancel }]}
      />
    </div>
  );
};
